import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/scanner-activation/edit/$id')({
  beforeLoad: () => getTitleContextSlice('Edit Scanner Activation'),
});
